import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Product from '../../models/Product'

export interface ProductListState extends PaginatedApiState {
  products?: Product[] 
}

const ProductList = (state: ProductListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProductListState>('PRODUCT_LIST')(state, action)
  }
}

export default ProductList
